<template>
    <div
        id="awards-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <award
            v-for="(award, index) in data.awards"
            :key="index"
            :name="award.name"
            :description="award.description"
            :icon="award.icon"
        />
        <base-text type="p" class="note">
            <em>{{ data.note }}</em>
        </base-text>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/awards.md';

    import Award from '../components/Award';

    export default {
        name: 'awards',

        mixins: [dataLoader(data)],

        components: {
            Award,
        },
    };
</script>

<style lang="scss" scoped>
    #awards-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }

        .note {
            margin-top: $standard-space;
        }

        &.mobile {
            .note {
                margin-top: $standard-space-mobile;
            }
        }
    }
</style>
